import { createStore } from 'vuex';

export default createStore({
  state: {
    count: 0,
    app: {
      name: 'Admin ACARA',
    },
    menuOpenState: {
    },
    priceCategory: null,
    habitualistaData: null,
    concessionaireData:null,
    userData:null,
    conferencesData: null,
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    setPriceCategory(state, category) {
      state.priceCategory = category;
    },
    setMenuOpenState(state, { isOpen, menuKey }) {
      state.menuOpenState = { 
        ...state.menuOpenState,
        [menuKey]: isOpen 
      };
    },
    setMenuIndicesType(state, type) {
      state.menuIndices.type = type;
    },
    setHabitualistaData(state, data) { 
      state.habitualistaData = data;
    },
    setConcessionaireData(state, payload) {
      const concessionaire = payload?.data || {}; 
      state.concessionaireData = concessionaire; 
    },
    setUserData(state, payload) {
      const user = payload || {}; 
      state.userData = user; 
    },
    resetUserData(state) {
      state.userData = null;
    },
    setConferencesData(state, data) {
      state.conferencesData = data;
    },
  },
  actions: {
    increment({ commit }) {
      commit('increment');
    },
    setPriceCategory({ commit }, category) {
      commit('setPriceCategory', category);
    },
    setMenuIndicesType({ commit }, type) {
      commit('setMenuIndicesType', type);
    },
    updateHabitualistaData({ commit }, data) { 
      commit('setHabitualistaData', data);
    },
    updateConcessionaireData({ commit }, data) { 
      commit('setConcessionaireData', data);
    },
    updateUserData({ commit }, data) { 
      commit('setUserData', data);
    },
    resetUserData({ commit }) {
      commit("resetUserData");
    },
    updateConferencesData({ commit }, data) {
      commit('setConferencesData', data);
    }
  },
  modules: {},
});
